/**
 * Analytics.js
 *
 * (C) 2013-2016 Segment.io Inc.
 */

import Analytics from "./analytics";

export default Analytics;
